// Generated by CoffeeScript 1.12.7
(function () {
  module.exports = function (createUi) {
    return createUi(require("./ConcentricSpinner.html"));
  };
}.call(this));
